import { render } from "./PortfolioSection.vue?vue&type=template&id=3ddcc471&scoped=true"
import script from "./PortfolioSection.vue?vue&type=script&lang=js"
export * from "./PortfolioSection.vue?vue&type=script&lang=js"

import "./PortfolioSection.vue?vue&type=style&index=0&id=3ddcc471&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ddcc471"]])

export default __exports__